/**
 * Das Club-Postfach im Orga-Bereich. Backend-Spiegel:
 * functions/shared/clubInbox.js - beide synchron halten,
 * src/__tests__/clubInboxSync.test.js prüft genau das.
 *
 * Hier liegt nur, was die Oberfläche braucht: Stände, Beschriftungen,
 * Grenzen und die Zugriffsentscheidung. Das Umwandeln von Mails passiert
 * ausschließlich auf dem Server.
 */

export const INBOX_STATUS = {
  OPEN: 'offen',
  IN_PROGRESS: 'in_arbeit',
  DONE: 'erledigt',
};

export const ALL_INBOX_STATUSES = Object.values(INBOX_STATUS);

export const INBOX_STATUS_LABELS = {
  offen: 'Offen',
  in_arbeit: 'In Arbeit',
  erledigt: 'Erledigt',
};

export const INBOX_REPLY_MAX = 10000;
export const INBOX_RETENTION_DAYS = 90;

/**
 * Darf jemand ins Club-Postfach? Admins immer, Organisatoren nur mit dem
 * einzeln freigeschalteten `inboxAccess`. Im Browser nur für die Anzeige -
 * die Grenze ziehen firestore.rules und die Cloud Functions.
 */
export function hasInboxAccess({ isAdmin, profile } = {}) {
  if (isAdmin === true) return true;
  return (
    profile?.status === 'active' && profile?.isOrganizer === true && profile?.inboxAccess === true
  );
}

/** Wie viele Mails unter jedem Filter stehen - für die Zähler an den Chips. */
export function countByStatus(mails) {
  const zaehler = { offen: 0, in_arbeit: 0, erledigt: 0 };
  for (const mail of mails ?? []) {
    if (zaehler[mail?.status] !== undefined) zaehler[mail.status] += 1;
  }
  return zaehler;
}

/** Anzeigename eines Absenders: Name, sonst die Adresse. */
export function senderLabel(mail) {
  return mail?.from?.name || mail?.from?.address || 'Unbekannt';
}
